import { useEffect } from 'react';
import { Form, Input, Button, Space, Modal, Switch, Row, Col } from 'antd';
import CustomerService from "services/customer"
import { useApp } from 'contexts/app';

const service = new CustomerService();

const CustomerLoginEdit = ({ id, open, onClose, onSave }) => {
  const { showLoading, showNotify } = useApp();
  const [form] = Form.useForm();

  useEffect(() => {
    if (open && id) {
      loadCustomer();
    }
  }, [open, id]);

  const createRandomPassword = () => {
    return Math.random().toString(36).slice(-8);
  }

  const onResetPassword = () => {
    var newPassword = createRandomPassword();
    form.setFieldValue("password", newPassword);
  }

  const onCopyPassword = async () => {
    var password = form.getFieldValue("password");
    if (!password) {
      return;
    }
    await window.navigator.clipboard.writeText(password);
  }

  const loadCustomer = async () => {
    var customer = await service.getByID(id);
    if (customer) {
      form.setFieldsValue({
        id: customer.id,
        account: customer.account || customer.phone,
        allow_login: customer.allow_login !== false,
        password: undefined,
      });
    }
  }

  const btnSaveClick = () => {
    form.submit();
  }

  const onFinish = async values => {
    showLoading(true);
    if (!values.password) {
      delete values.password;
    }
    var data = await service.update(values);
    showLoading(false);

    if (data && onSave) {
      await onSave(data);
    }
    showNotify("Đã cập nhật");
    onClose();
  };

  return (
    <Modal
      title="Quản lý đăng nhập khách hàng"
      closable={{ 'aria-label': 'Custom Close Button' }}
      open={open}
      onCancel={onClose}
      footer={<Space>
        <Button onClick={onClose}>Close</Button>
        <Button onClick={btnSaveClick} type='primary'>Save</Button>
      </Space>}
    >
      <Form layout='vertical' form={form} onFinish={onFinish}>
        <Form.Item hidden name={"id"}>
          <Input />
        </Form.Item>

        <Row gutter={12}>
          <Col span={24}>
            <Form.Item
              label="Tài khoản đăng nhập"
              name={"account"}
              rules={[
                { required: true, message: 'Bạn phải nhập tài khoản đăng nhập' },
                {
                  validator: async (_, value) => {
                    return new Promise(async (r, e) => {
                      if (!value) {
                        r();
                        return;
                      }
                      try {
                        var data = await service.getByAccount(value);
                        if (data?.id && data.id != id) {
                          e(new Error('Tài khoản này đã được dùng cho khách hàng khác'));
                          return;
                        }
                        r();
                      } catch (error) {
                        r();
                      }
                    })
                  },
                }
              ]}
            >
              <Input placeholder='Mặc định là số điện thoại' />
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item
              label="Mật khẩu đăng nhập"
              name={"password"}
              extra="Để trống nếu không đổi mật khẩu"
            >
              <Input.Password
                placeholder='Nhập mật khẩu mới'
                addonAfter={
                  <Space size={0}>
                    <Button type='link' onClick={onResetPassword} size='small'>Ngẫu nhiên</Button>
                    <Button type='link' onClick={onCopyPassword} size='small'>Copy</Button>
                  </Space>
                }
              />
            </Form.Item>
          </Col>
        </Row>

        <Form.Item
          label="Cho phép đăng nhập"
          name={"allow_login"}
          valuePropName='checked'
          initialValue={true}
        >
          <Switch checkedChildren="Cho phép" unCheckedChildren="Tắt" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default CustomerLoginEdit;